import React from 'react';
import MenuUnfoldOutlined from '@haier/icons/MenuUnfoldOutlined';
import MenufoldOutlined from '@haier/icons/MenufoldOutlined';
import PageHeader from '../../../page-header';
import { MainFrameContext } from '../../index';
import Crumb from '../Crumb';
const MainPageHeader = (props) => {
    const { prefixCls, crumbData, collapsed, toggleCollapsed } = React.useContext(MainFrameContext);
    const { crumbExtra, showCrumbHeader = false, onClick, crumbClickable = false } = props;
    const handleCrumbClick = (item) => onClick === null || onClick === void 0 ? void 0 : onClick(item);
    const dom = (React.createElement("div", { className: `${prefixCls}-page-header-crumb` },
        showCrumbHeader ? (React.createElement("div", { className: `${prefixCls}-crumb-wrap` },
            React.createElement("span", { className: `${prefixCls}-trigger`, onClick: toggleCollapsed }, collapsed ? React.createElement(MenuUnfoldOutlined, null) : React.createElement(MenufoldOutlined, null)),
            React.createElement(Crumb, { data: crumbData !== null && crumbData !== void 0 ? crumbData : [], crumbClickable: crumbClickable, onClick: handleCrumbClick }))) : (React.createElement(Crumb, { data: crumbData !== null && crumbData !== void 0 ? crumbData : [], crumbClickable: crumbClickable, onClick: handleCrumbClick })),
        crumbExtra && React.createElement("div", { className: `${prefixCls}-page-header-crumb-extra` }, crumbExtra)));
    if (showCrumbHeader) {
        /* v3.4.30 */
        return (React.createElement(PageHeader, Object.assign({ className: `${prefixCls}-page-header ${prefixCls}-page-header-fixed`, breadcrumb: dom }, props)));
    }
    else if (!crumbData || (crumbData === null || crumbData === void 0 ? void 0 : crumbData.length) <= 1) {
        return null;
    }
    return (React.createElement(PageHeader, Object.assign({ className: `${prefixCls}-page-header`, breadcrumb: dom }, props)));
};
export default MainPageHeader;
